(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wow_card_stack_scroll"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sectionId = '{{ section_id }}';
    const section = document.querySelector(`#wow-card-stack-scroll-${sectionId}`);
    if (!section) return;

    const cards = section.querySelectorAll('.wow-card');
    const animationSpeed = parseFloat(section.dataset.animationSpeed) || 1;
    const animationEasing = section.dataset.animationEasing || 'ease-out';

    let ticking = false;

    function wowAnimateCards() {
      const sectionRect = section.getBoundingClientRect();
      const sectionTop = sectionRect.top;
      const sectionHeight = sectionRect.height;
      const windowHeight = window.innerHeight;

      cards.forEach((card, index) => {
        const cardRect = card.getBoundingClientRect();
        const cardTop = cardRect.top;
        
        // Calculate progress through the section
        const scrollProgress = Math.max(0, Math.min(1, (windowHeight - cardTop) / windowHeight));
        
        // Stagger effect - each card moves at a different rate
        const staggerFactor = 1 + (index * 0.15);
        const translateY = -(scrollProgress * 100 * animationSpeed * staggerFactor);
        const scale = 1 - (scrollProgress * 0.05 * index);
        const opacity = 1 - (scrollProgress * 0.3 * index);
        
        // Get original rotation from inline style
        if (!card.dataset.originalRotation) {
          card.dataset.originalRotation = parseFloat(card.style.transform.match(/rotate\(([-\d.]+)deg\)/)?.[1] || 0);
        }
        const originalRotation = parseFloat(card.dataset.originalRotation);
        
        // Set CSS custom properties for scroll animation
        card.style.setProperty('--scroll-y', `${translateY}px`);
        card.style.setProperty('--scroll-rotation', `${originalRotation}deg`);
        card.style.setProperty('--scroll-scale', Math.max(0.9, scale));
        card.style.opacity = Math.max(0.3, opacity);
        
        // Apply transform using CSS variables (allows hover effects to work)
        card.style.transform = `
          translateY(calc(var(--scroll-y) + var(--hover-lift, 0px))) 
          rotate(var(--scroll-rotation)) 
          scale(calc(var(--scroll-scale) * var(--hover-scale, 1)))
        `;
        card.style.transition = `transform 0.1s ${animationEasing}, opacity 0.3s ease, box-shadow 0.3s ease`;
      });

      ticking = false;
    }

    function wowRequestTick() {
      if (!ticking) {
        window.requestAnimationFrame(wowAnimateCards);
        ticking = true;
      }
    }

    // Initialize on scroll and resize
    window.addEventListener('scroll', wowRequestTick, { passive: true });
    window.addEventListener('resize', wowRequestTick, { passive: true });
    
    // Initial animation
    wowAnimateCards();

    // Cleanup on page unload (for Shopify theme editor)
    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:unload', function(event) {
        if (event.detail.sectionId === sectionId) {
          window.removeEventListener('scroll', wowRequestTick);
          window.removeEventListener('resize', wowRequestTick);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
